<template>
  <div>
    <div class="modal-title mb-16">
      {{t('Pay only for the features you actually use.')}}
    </div>
    <div class="font-weight-bold mb-16 subtitle">
      {{t('Activate the selected feature on your current plan without changing the subscription.')}}
    </div>

    <div class="green-box mb-16">
      <div class="green-box-top">
        <span class="font-weight-bold">{{ t('Selected option') }}:</span>&nbsp;
        {{planLimitsKeyText[data.planLimit]}}
      </div>
      <div>
        <span class="green-box__price">${{ numeral(store.billingAddons[data.planLimit].price/ 100).format('0,0[.]00')}}</span>&nbsp;
        <span class="green-box__mo">/ {{t('mo')}}</span>
      </div>
      <div class="green-box__cost-per-month">{{t('Cost per Month')}}</div>
    </div>
    <p v-html="t('Billed immediately after clicking on <b>Buy Now</b>.')"></p>
    <p>
      {{t('The amount will be calculated from the current day until the end of the billing period. Next payment will be made on the subscription renewal {0}.',[formatBillingDate(nextBillingAt)])}}
    </p>
    <p>
      {{t('To cancel the add-on, access the Subscription section and click on Manage button.')}}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import numeral from 'numeral';
import { useI18n, usePlanLimits } from '@/composables';
import { formatBillingDate, getNextBillingAt } from '@/services/utils/billing-format';
import { useStore } from '@/store';

defineProps<{
  estimate?: any;
  data: {
    planLimit: null | keyof BillingLimits;
  };
}>();

const { t } = useI18n();
const { planLimitsKeyText } = usePlanLimits(undefined);
const store = useStore();
const nextBillingAt = computed(() => getNextBillingAt(store.billing));
</script>

<style lang="scss" scoped>
@import '@/styles/components/manage-addon.scss';

.modal-title{
  font-size:20px;
  font-weight:bold;
}

.subtitle{
  font-size:14px;
}
</style>
